import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { DateFormatter } from '@repo/toolkit/date'
import Badge from '@repo/ui/badge'
import { InformationIcon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'

import useTranslate from '../../../lib/hooks/use-translate'
import {
  endOfJourneyScanReadingPausedMapping,
  EndOfJourneyScanReadingStateEnum
} from '../../../lib/types/enums/end-of-stay-template/end-of-journey-scan.enum'
import { EndOfJourneyScanReadingStatus } from '../../../lib/types/models/end-of-journey-scan/end-of-journey-scan'

type Props = {
  readingStatus?: EndOfJourneyScanReadingStatus
}

// Shown while the reading is paused: uploads are still accepted, they wait until it resumes
const EndOfJourneyScanReadingBanner = ({ readingStatus }: Props) => {
  const { t } = useTranslate()

  if (!readingStatus || readingStatus.state === EndOfJourneyScanReadingStateEnum.AVAILABLE)
    return null

  const color = tailwindColors.orange.DEFAULT

  return (
    <Badge
      variant="orange"
      size="flexible"
      className="w-full items-start rounded p-2"
      iconPosition="start"
      iconClassName="flex h-4 shrink-0 items-center"
      icon={<InformationIcon fill={color} className="h-4 w-4" />}
      textClassName="flex min-w-0 flex-col gap-1"
      text={
        <>
          {/* Same line height as the icon so both stay aligned on the first line */}
          <Typography
            as="span"
            variant="small-semibold"
            color={color}
            style={{ lineHeight: '16px' }}
          >
            {t(endOfJourneyScanReadingPausedMapping[readingStatus.state])}
          </Typography>
          {readingStatus.resumesAutomatically && (
            <Typography as="span" variant="small" color={color}>
              {t('end.of.journey.scans.reading.paused.resumes.automatically')}
            </Typography>
          )}
          {readingStatus.since && (
            <Typography as="span" variant="small" color={color}>
              {t('end.of.journey.scans.reading.paused.since', {
                date: `${DateFormatter.DDMMYYYY(readingStatus.since)} ${DateFormatter.HHmm(readingStatus.since)}`
              })}
            </Typography>
          )}
        </>
      }
    />
  )
}

export default EndOfJourneyScanReadingBanner
